import { render, staticRenderFns } from "./MaterialExamSubjectAdd.vue?vue&type=template&id=3133a03e&scoped=true"
import script from "./MaterialExamSubjectAdd.vue?vue&type=script&lang=js"
export * from "./MaterialExamSubjectAdd.vue?vue&type=script&lang=js"
import style0 from "./MaterialExamSubjectAdd.vue?vue&type=style&index=0&id=3133a03e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3133a03e",
  null
  
)

export default component.exports